import { rectIsHidden } from '@/utils';
import useFormTypePositionButton from './useFormTypePositionButton';

const windowBoxShadow = '0px 5px 40px rgb(0,0,0,0.16)';

export default function useWrapStyle({ feedbackButtonRef, formOpen, formWidth }) {
	const { position, formType, buttonType } = useFormTypePositionButton();

	const style = {
		position: 'fixed',
		zIndex: 2000000001,
		backfaceVisibility: 'hidden',
		transition: 'opacity .3s, transform .3s, visibility .225s',
		'backface-visibility': 'hidden'
	};

	if (formType === 'slide') {
		//	style.width = formWidth;
		style.boxShadow = formOpen ? windowBoxShadow : 'none';

		if (buttonType === 'float') {
			style.opacity = formOpen ? 1 : 0;
		}

		const formOffset = getFormOffset({
			formWidth,
			button: feedbackButtonRef.current,
			buttonType,
			position
		});

		return {
			formOffset,
			wrapStyle: {
				...style,
				...getSlideStyle({
					formOffset,
					formOpen,
					position
				})
			}
		};
	}

	if (formType === 'modal') {
		return {
			wrapStyle: {
				...style,
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				overflowY: formOpen ? 'auto' : 'hidden',
				'-webkit-overflow-scrolling': 'touch',
				backfaceVisibility: 'hidden',
				width: '100%',
				minHeight: '100%',
				visibility: formOpen ? 'visible' : 'hidden',
				pointerEvents: formOpen ? 'auto' : 'none',
				zIndex: !formOpen ? -1 : 1999999999
			}
		};
	}

	return { wrapStyle: style };
}

function getSlideStyle({ formOpen, formOffset, position }) {
	switch (position) {
		case 'right':
			return {
				top: '10%',
				top: 'calc(10% + 5px)',
				bottom: 'auto',
				left: 'auto',
				right: formOpen ? formOffset : 0,
				transform: formOpen ? 'translateX(0)' : 'translateX(100%)',
				'-webkit-transform': formOpen ? 'translateX(0)' : 'translateX(100%)'
			};

		case 'bottom-right':
			return {
				top: 'auto',
				bottom: formOpen ? formOffset : '-5px',
				left: 'auto',
				right: '12px',
				transform: formOpen ? 'translateY(0)' : 'translateY(100%)',
				'-webkit-transform': formOpen ? 'translateY(0)' : 'translateY(100%)'
			};

		case 'bottom-left':
			return {
				top: 'auto',
				bottom: formOpen ? formOffset : '-5px',
				left: '12px',
				right: 'auto',
				transform: formOpen ? 'translateY(0)' : 'translateY(100%)',
				'-webkit-transform': formOpen ? 'translateY(0)' : 'translateY(100%)'
			};

		case 'left':
			return {
				top: '10%',
				top: 'calc(10% + 5px)',
				left: formOpen ? formOffset : 0,
				right: 'auto',
				transform: formOpen ? 'translateX(0)' : 'translateX(-100%)',
				'-webkit-transform': formOpen ? 'translateX(0)' : 'translateX(-100%)'
			};

		default:
			return {};
	}
}

function getFormOffset({ button, buttonType, position, formWidth }) {
	const maxSpace = spacing => (spacing > 24 ? 24 : spacing);

	if (!button) {
		return 0;
	}

	const buttonRect = button?.getBoundingClientRect();

	if (buttonType !== 'float' || rectIsHidden(buttonRect)) {
		return 0;
	}

	switch (position) {
		case 'right':
			const offsetRight =
				window.innerWidth -
				buttonRect.left +
				maxSpace(window.innerWidth - buttonRect.right);
			if (offsetRight + formWidth > window.innerWidth) {
				return 12;
			}
			return offsetRight;

		case 'left':
			const offsetLeft = buttonRect.right + maxSpace(buttonRect.left);
			if (offsetLeft + formWidth > window.innerWidth) {
				return 12;
			}
			return offsetLeft;

		case 'bottom-right':
		case 'bottom-left':
		default:
			return (
				window.innerHeight -
				buttonRect.top +
				maxSpace(window.innerHeight - buttonRect.bottom)
			);
	}
}
